var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-0 px-0",attrs:{"fluid":"","tag":"section"}},[_c('base-material-table',{ref:"table",attrs:{"flat":"","item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }